import {
    observer
} from 'mobx-react-lite';
import type { ApplicationSdk } from '../stores';
import Navigation from './manager/Navigation';
import OrderOverview from './manager/OrderOverview';
import ProductOverview from './manager/ProductOverview';
import ObjectOverview from './manager/ObjectOverview';
import CleanerOverview from './manager/CleanerOverview';
import ManagerOverview from './manager/ManagerOverview';
import TrainingOverview from './manager/TrainingOverview';

const ManagerView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    return <>
        <Navigation sdk={sdk} />
        {sdk.locationAction === 'orders' ? <OrderOverview sdk={sdk} /> : null}
        {sdk.locationAction === 'products' ? <ProductOverview sdk={sdk} /> : null}
        {sdk.locationAction === 'objects' ? <ObjectOverview sdk={sdk} /> : null}
        {sdk.locationAction === 'cleaner' ? <CleanerOverview sdk={sdk} /> : null}
        {sdk.locationAction === 'manager' ? <ManagerOverview sdk={sdk} /> : null}
        {sdk.locationAction === 'training' ? <TrainingOverview sdk={sdk} /> : null}
    </>
});

export default ManagerView;